import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Phone, Video, CheckCircle2, ExternalLink } from "lucide-react";
import MioDottoreWidget from "../components/MioDottore";
import useSEO from "../hooks/useSEO";
import "./PrenotaAppuntamento.css";

const MIODOTTORE_URL =
  "https://www.miodottore.it/anna-antoniozzi/psicologo-clinico-psicologo/rieti";

const PrenotaAppuntamento = () => {
  const navigate = useNavigate();
  useSEO({
    title: "La Psicologa Anna | Prenota un Appuntamento",
    description:
      "Prenota un colloquio con la Dott.ssa Anna Antoniozzi, disponibile anche per sedute online su Meet.",
    canonicalPath: "/prenota-appuntamento",
  });

  return (
    <div className="prenota">
      <section className="section section--paper prenota-hero">
        <div className="container prenota-grid">
          <motion.div
            className="prenota-info"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="eyebrow">Prenotazioni</p>
            <h1 className="display prenota-title">Prenota il tuo appuntamento</h1>
            <p className="lead">
              Puoi prenotare direttamente dal riquadro qui accanto, oppure
              chiamarmi. Sono disponibile anche per sedute online su Meet.
            </p>

            <ul className="prenota-list">
              <li><CheckCircle2 size={20} /> Primo colloquio conoscitivo</li>
              <li><Video size={20} /> In studio a Rieti o online su Meet</li>
              <li><CheckCircle2 size={20} /> Sedute di 45 minuti</li>
            </ul>

            <div className="prenota-actions">
              <a href="tel:+393791566652" className="btn btn--primary">
                <Phone size={18} /> +39 379 156 6652
              </a>
              <button className="btn btn--ghost" onClick={() => navigate("/contatti")}>
                Contatti
              </button>
            </div>
          </motion.div>

          <motion.div
            className="prenota-widget-col"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.12 }}
          >
            <div className="prenota-widget">
              <MioDottoreWidget />
            </div>
            <a
              className="prenota-fallback"
              href={MIODOTTORE_URL}
              target="_blank"
              rel="noreferrer noopener"
            >
              <ExternalLink size={17} />
              Il calendario non si apre? Prenota su MioDottore
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrenotaAppuntamento;
